import { observer } from "mobx-react";
import React from "react";
import { Alert, Text, Group, Title } from "@mantine/core";
import { Cubby } from "../stores/Cubby";

const Disclaimers = observer(({ cubby }: { cubby: Cubby }) => {
  //console.log("last_recovery_attempt raw value:", cubby.last_recovery_attempt);

  // Calculate the date of the last recovery attempt
  const lastRecoveryTime = cubby.last_recovery_attempt
    ? new Date(Date.now() - cubby.last_recovery_attempt * 60 * 1000)
    : null;

  // Calculate the recovery deadline (two weeks after the last recovery attempt)
  const recoveryDeadline = lastRecoveryTime
    ? new Date(
        lastRecoveryTime.getTime() + 14 * 24 * 60 * 60 * 1000
      ).toLocaleDateString()
    : null;

  // Calculate the minutes ago
  const minutesAgo = cubby.last_recovery_attempt;

  return (
    <>
      <Group>
        {cubby.last_recovery_attempt != null && (
          <Alert>
            <Title>
              This node was recovered, you should withdraw all BTC funds
            </Title>
            <Text size="lg">
              Recovery was done: {minutesAgo} minutes ago. If you had any open
              channels, those channels have been forced-closed.... and you
              should keep this node running for at least two weeks from the last
              recovery attempt so any balances can settle to your BTC balance.
              That date is calculated as <b>{recoveryDeadline}</b>.
            </Text>
          </Alert>
        )}
      </Group>
      <Group>
        {cubby.cubbyNetwork === "testnet" && (
          <Text size="xs" c="dimmed">
            You are using Testnet3.
            {/* Coins have no value. This network will soon
            be replaced by Testnet4. When we switch to Testnet4, this node will
            be automatically destroyed. */}
          </Text>
        )}
      </Group>
      <Group>
        <Text size="xs" c="dimmed">
          <>
            {cubby.cubbyUuid}
            {cubby.alias && ` | ${cubby.alias}`}
          </>
        </Text>
      </Group>
    </>
  );
});

export default Disclaimers;
